export const reactSelectStyles = {
  control: (base, state) => ({
    ...base,
    width: '100%',
    height: '50px',
    border: '2px solid rgba(8, 76, 148, 0.2)',
    borderRadius: '5px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: 'rgba(8, 76, 148, 0.2)',
    }
  }),
  valueContainer: (base) => ({
    ...base,
    fontSize: '16px',
    lineHeight: '20px',
  }),
  option: (base, state) => ({
    ...base,
    fontWeight: state.isSelected ? 'bold' : '400', // Bold for selected option
    backgroundColor: "white",
    color: "#6c757d",
    '&:hover': {
      backgroundColor: '#f6f6f6', // Hover effect
    },
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: '16px',
    lineHeight: '20px'
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'rgba(8, 76, 148, 0.6)', // Color for custom arrow
    '&:hover': {
      color: 'rgba(8, 76, 148, 0.8)',
    },
  }),
  menu: (base) => ({
    ...base,
    width: '100%',
    zIndex: 100,
  }),
};

export const languageStyles = {
  control: (base, state) => ({
    ...base,
    width: '100%', // Adjust the percentage or set a fixed width if needed
    minWidth: '120px', // Set a minimum width
    height: '20px', // Increase height
    border: '2px solid rgba(8, 76, 148, 0.2)',
    borderRadius: '8px', // Slightly more rounded corners
    boxShadow: 'none',
    fontSize: '14px', // Increase font size
    lineHeight: '22px', // Adjust line height
    '&:hover': {
      borderColor: 'rgba(8, 76, 148, 0.4)', // Slightly darker on hover
    },
  }),
  valueContainer: (base) => ({
    ...base,
    fontSize: '14px', // Match control font size
    lineHeight: '22px',
    padding: '4px 10px', // Add padding for better spacing
  }),
  option: (base, state) => ({
    ...base,
    fontWeight: state.isSelected ? 'bold' : '400',
    fontSize: '14px', // Adjust option font size
    lineHeight: '20px',
    backgroundColor: state.isFocused ? '#f0f0f0' : 'white', // Add focus state
    color: "#6c757d",
    '&:hover': {
      backgroundColor: '#e9ecef', // Subtle hover effect
    },
  }),
  singleValue: (base) => ({
    ...base,
    fontSize: '14px',
    lineHeight: '22px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  dropdownIndicator: (base) => ({
    ...base,
    color: 'rgba(8, 76, 148, 0.6)',
    '&:hover': {
      color: 'rgba(8, 76, 148, 0.8)',
    },
  }),
  menu: (base) => ({
    ...base,
    width: '100%', // Ensure it matches the control's width
    minWidth: '120px', // Set a minimum width to align with control
    zIndex: 100,
  }),
};